import React from 'react';

import { connect } from 'react-redux';
import { change as changeAction } from 'redux-form';
import { Edit } from 'components/detail';
import { SimpleForm } from 'components/form';
import { TextInput, BooleanInput, NumberInput, SelectInput } from 'components/input';

import { maxLength } from 'components/form';

import {
  COUNTRY_VN,
  COUNTRY_TH,
  DisabledSelectOptions,
  DisabledInputOptions,
} from 'util/constants';

import * as urls from './urls';
import * as utils from './utils';
import { } from 'util/constants';

class ProductEditBase extends React.Component {
  render () {
    const { category } = this.props.record || {};
    const isVnBuyDevice = process.env.REACT_APP_COUNTRY === COUNTRY_VN && category === utils.BUY_SUNMI_DEVICE;
    const priceOption = isVnBuyDevice ?  {value: 'by formula', disabled: true} : null;
    const priceRequired = isVnBuyDevice ? false : true;
    const priceInput = isVnBuyDevice ? <TextInput options={priceOption} source="price" label="Price" isRequired={priceRequired} /> 
    : <NumberInput options={priceOption} source='price' label='Price' isRequired={priceRequired} />

    return (
      <Edit editBackendPath={urls.productEditBackendPath} updateDataOnMount={false} {...this.props} >
        <SimpleForm>
          <SelectInput
            source='category'
            label='Category'
            isRequired={true}
            options={DisabledSelectOptions}
            choices={
              process.env.REACT_APP_COUNTRY === COUNTRY_TH
                ? utils.PRODUCT_CATEGORY_CHOICES_TH
                : utils.PRODUCT_CATEGORY_CHOICES
            }
          />
          <TextInput options={DisabledInputOptions} source='denomination' label='Denomination' isRequired={true}/>
          <TextInput source='en' label='Name' isRequired={true}/>
          <TextInput source='translation' label='Name(Local)' isRequired={true}/>
          <TextInput source='description_en' label='Description' isRequired={true} validators={[maxLength(100)]}/>
          <TextInput source='description_translation' label='Description(Local)' isRequired={true} validators={[maxLength(100)]}/>
          {priceInput}
          <TextInput options={priceOption} source="price_en" label="Price Display" isRequired={priceRequired}/>
          <TextInput options={priceOption} source="price_translation" label="Price Display(Local)" isRequired={priceRequired}/>
          <NumberInput source='sequence' label='Sequence' isRequired={true}/>
          <BooleanInput source='is_active' label="Status" isRequired={true}/>
        </SimpleForm>
      </Edit>
    );

  }
}



const mapStateToProps = (state, props) => {
  return {
    record: state.admin[props.resource] && state.admin[props.resource].data ? state.admin[props.resource].data[decodeURIComponent(props.match.params.id)]:null,
  };
};

export const ProductEdit = connect(
  mapStateToProps, 
  {
    change: changeAction,
  }
)(ProductEditBase);


// WEBPACK FOOTER //
// ./src/routes/product/ProductEdit.js